import { AppException } from './AppException';

export class ServiceException extends AppException {
  public readonly name: string;
  public readonly methodName: string;
  public readonly args: Record<string, unknown>;

  constructor(
    name: string,
    methodName: string,
    args: Record<string, unknown>,
    err: Error,
    data: unknown,
    sendToSentry = true,
  ) {
    super(err, data, sendToSentry);
    this.name = name;
    this.methodName = methodName;
    this.args = args;
  }

  get extras(): any {
    return {
      type: 'Service',
      service: this.name,
      methodName: this.methodName,
      args: this.args,
    };
  }

  static from(
    name: string,
    methodName: string,
    args: Record<string, unknown>,
    err: unknown,
    data: unknown,
    sendToSentry = true,
  ): ServiceException {
    return new ServiceException(name, methodName, args, err as Error, data, sendToSentry);
  }
}
